import { render, staticRenderFns } from "./carportAllOrderList.vue?vue&type=template&id=673878c2&"
import script from "./carportAllOrderList.vue?vue&type=script&lang=js&"
export * from "./carportAllOrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports